import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "../openapi";
import { MealTypeResponse } from "../openapi/client";
import { RootState } from "../store";
import { setMealTypes as setMealTypesStore } from "../store/mealSlice";

export default function useMealTypes() {
  const [mealTypes, setMealTypes] = useState<MealTypeResponse[]>([]);

  useEffect(() => {
    const getMealTypes = async () => {
      try {
        const res = await Api.Meal.getTypes();
        setMealTypes(res.data);
      } catch (error) {}
    };
    getMealTypes();
  }, []);
  return mealTypes;
}
